
import Inventory from "@/state/Inventory";
import { Item, ItemStringQuantity, ItemTransform } from "@/types";
import { defineComponent } from "vue";
import ItemTF from "@/data/ItemTransforms.json";
import CloseButton from "../shared/CloseButton.vue";

const ItemTransforms: { [key: string]: ItemTransform } = ItemTF;

export default defineComponent({
  components: { CloseButton },
  props: {
    lastRoll: {
      type: Object as () => Item[],
      required: true,
    },
    inventory: {
      type: Object as () => Inventory,
      required: true,
    },
    extraRewards: {
      // TODO: combine this information into lastRoll
      // along with if things are new
      type: Object as () => ItemStringQuantity[],
      required: true,
    },
  },
  emits: ["exit"],
  data() {
    return {
      ItemTransforms: ItemTransforms,
      glowStyles: {
        3: { outline: "#a2cdf5", glow: "royalblue", intensity: "" },
        4: { outline: "white", glow: "#8275ff", intensity: "" },
        5: { outline: "white", glow: "#ffd479", intensity: "" },
      } as {
        [key: number]: { glow: string; outline: string; intensity: string };
      },
    };
  },
  computed: {
    sortedLastRoll(): Item[] {
      const item = (star: number) =>
        this.lastRoll
          .filter(({ rarity }) => rarity === star)
          .sort(
            (a, b) =>
              // whichever one is newer goes first
              // (if there's only one in inv)
              // TODO: add support for dedicated isNew flag
              // because there's no way you can practically
              // check it
              // TODO: sort by first occurence and then
              // group names instead of sorting by name
              +(this.inventory.inventory[a.id] === 1) -
              +(this.inventory.inventory[b.id] === 1)
          )
          .sort((a, b) => a.type.localeCompare(b.type))
          .sort((a, b) => a.name.localeCompare(b.name));
      return [...item(5), ...item(4), ...item(3)];
    },
  },
  methods: {
    exit(): void {
      this.$emit("exit");
    },
  },
});
